import React, { Component } from 'react';
import PropTypes from 'prop-types';

import styles from './Container.module.scss';

export default class Container extends Component {
  static propTypes = {
    className: PropTypes.string,
    children: PropTypes.node.isRequired
  };

  static defaultProps = {
    className: ''
  };

  render() {
    const { className } = this.props;

    return (
      <div className={`${className} ${styles.Container}`}>
        {this.props.children}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/Layout/components/Container/Container.js